import _default from './oneLineCommaListsOr';
export { _default as default };
